import type { AppRegistryPage } from '@plato/app-meta/ai-meta';
import { PageTitle } from '@plato/app-shared/components/page-title';
import { usePageAiMeta } from '@plato/app-shared/hooks/use-page-ai-meta';
import { useTranslation } from 'react-i18next';
import { useAiChatExplorerColumns } from '../features/explorer/hooks/use-ai-chat-explorer-columns.ts';
import { ExplorerViewPage } from '../features/explorer/pages/explorer-view-page.tsx';

export function useExplorerAiMeta(): AppRegistryPage {
    const { t } = useTranslation();
    return usePageAiMeta(
        {
            path: '/explorer',
            title: t('page_title__explorer', { ns: 'common' }),
            description:
                'The {{metric}} analysis pivot for the whole tenant. Each tab breaks the listed figures ' +
                'down by storage location, clerk, sales rep, customer, industry, merchandise group, ' +
                'product group, product or supplier, against the previous period, with a two-year ' +
                'sparkline per row. Selecting rows filters the other tabs, and the table exports to ' +
                'Excel where allowed. There is no chart on this page. For one customer or one product, ' +
                'the same pivot sits on their detail pages.',
        },
        useAiChatExplorerColumns(),
    );
}

function Explorer() {
    const { t } = useTranslation();

    return (
        <>
            <PageTitle title={t('page_title__explorer')} />
            <ExplorerViewPage />
        </>
    );
}

export default Explorer;
